import styled from 'styled-components';

export const ModalAccountInfo = styled.div`
  margin-bottom: 12px;
  font-weight: 500;
`;
